exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2,\nh3,\nh4 {\n  text-transform: uppercase; }\n\n.container-dashboard {\n  background: lightblue url(\"/assets/img/bg001.jpg\") repeat fixed center;\n  min-height: 100vh;\n  background-size: cover; }\n\napp-export-canvas {\n  position: absolute;\n  top: 10px;\n  right: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard3/dashboard3.component.scss
// module id = ../../../../../src/app/views/dashboards/dashboard3/dashboard3.component.scss
// module chunks = main